
const colors = {
    black:  '#000000',
    white: '#ffffff',
    blue: '#166AEA'
}

const categoryPath = '/explore/categories/';

export {
    colors,
    categoryPath
}